import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const BASE_REPORTS_URL = `${SERVER_API}/reports`;

export default {
  /**
   * Отчет с данными по карточке заявления
   *
   * @param {number} id
   * @returns {IEndpointData}
   */
  GET_REPORT_ISSUE_STEP_CHANGES(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${BASE_REPORTS_URL}/issues/${id.toString()}/step-changes`,
    };
  },
};
